import * as filtersConstants from '../constants/filters';

export const applyFiltersAction = () => ({
  type: filtersConstants.APPLY_FILTERS,
});

export const cancelFiltersAction = () => ({
  type: filtersConstants.CANCEL_FILTERS,
});

export const saveFiltersForCancelAction = (payload) => ({
  type: filtersConstants.SAVE_FILTERS_FOR_CANCEL,
  payload,
});
